/**
 * Creates range of numbers
 * @param from inclusive
 * @param to exclusive
 */
export function range(from: number, to: number): number[] {
  if(to <= from) {
    throw new Error("Parameter to must be greater than from");
  }

  return Array.from(new Array(to - from), (x, i) => i + from);
}